"use strict";

function RegoSearchService(guideWireService, transformers) {
	var formData = {},
		gwResponse = {}, // response as received from guideWire
		serviceResponse = {}, // response after being process by any registered transformers
		lastStatus = {}, // error or success in last service call
		transformers = transformers || {} ;

	function transformGWResponse(serviceName, resp) {
		var response = resp;
		if ( transformers.serviceName )
			response = transformers.serviceName.transform(resp);

		return response;
	}

	function processErrorResponse(serviceName, resp, errorFn) {
		gwResponse[serviceName]= resp;
		lastStatus[serviceName]=false;
		serviceResponse[serviceName] = transformGWResponse(serviceName, resp);
		errorFn(serviceResponse[serviceName]);
	}

	function processSuccessResponse(serviceName, resp, successFn) {
		gwResponse[serviceName]= resp;
		lastStatus[serviceName]= true;
		serviceResponse[serviceName] = transformGWResponse(serviceName, resp);
		successFn(serviceResponse[serviceName]);
	}

	function search(data, success, error) {

		guideWireService.regoSearch(data)
            .then(function(response) {
				//console.log(response.data);
                success(response.data);
            })
            .catch(function(response) {
                if(error) {
                    error(response);
                }
            });
	}

	function searchMake(data, success, error) {

		guideWireService.makeSearch(data)
            .then(function(response) {				
				var data1 = convertSearchMakeResponse(response.data.make);
                success(data1);
            })
            .catch(function(response) {
                if(error) {
                    error(response);
                }
            });
	}

	//after vgi uplift, payload changed
	function convertSearchMakeResponse(response) {
		var makes = []; 
		if (!response || response.length == 0) {
			return makes;
		}		
		for (var idx1 = 0; idx1 < response.length; idx1++) {
			var priorityNum1 = parseInt(response[idx1].priority);
			makes.push({
				name: response[idx1].description,
				code: response[idx1].makeCode,
				priority: (priorityNum1 !== NaN) ? priorityNum1 : 0,
			});
		}
		return makes;
	}

	function searchModel(data, success, error) {

		guideWireService.modelSearch(data)
            .then(function(response) {				
				var data2 = convertSearchModelResponse(response.data.model);
                success(data2);
            })
            .catch(function(response) {				
                if(error) {
                    error(response);
                }
            });
	}

	function convertSearchModelResponse(response) {
		var models = [];
		if (!response || response.length == 0) {
			return models;
		}		
		for (var idx2 = 0; idx2 < response.length; idx2++) {
			var priorityNum = parseInt(response[idx2].priority);
			models.push({
				name: response[idx2].description,
				code: response[idx2].modelCode,
				priority: (priorityNum !== NaN) ? priorityNum : 0,
			});
		}
		return models;
	}

	function searchCar(data, success, error) {

		guideWireService.carSearch(data)
            .then(function(response) {
				var searchedData = response.data;
				for (var i = 0; searchedData && i < searchedData.length; i++) {
					if (!searchedData[i].goodRetailPrice) {
						searchedData[i].goodRetailPrice = "0";
					}					
				}
				success(searchedData);
            })
            .catch(function(response) {
                if(error) {
                    error(response);
                }
            });
	}

	function getLastResponse(serviceName) {
		return serviceResponse[serviceName] ;
	}

	function getLastRequest(serviceName) {
		return formData[serviceName] ;
	}

	return {
		search: search,
		searchMake: searchMake,
		searchModel: searchModel,
		searchCar: searchCar,
		getLastRequest: getLastRequest,
		getLastResponse: getLastResponse,
	}
}

RegoSearchService.create=function(guideWireService) {
	var transformers = {
		search: function(resp) {
			return {
				year: resp.modelYear,
				make: resp.make,
				model: resp.model,
				series: resp.series,
				body: resp.bodyStyle,
				transmission: resp.gearType,
				drive: resp.driveDescription,
				engine: resp.engineDescription,
			}
		},
		searchMake: function(resp) {
			return {
				code: resp.code,
				name: resp.name
			}
		}
	}

	return new RegoSearchService(guideWireService)
}
